









































import { Component, Vue } from "vue-property-decorator";

@Component
export default class KeslingMenuPage extends Vue {
  goto(name: string) {
    if (this.$route.name !== name) {
      this.$router.push({ name });
    }
  }
}
